import {ResponsePaginateOptions} from "../../agent";
import {DoctorTitleCase, GeneralTitleCase, getDoctorTitle, getGeneralTitle, getPatientTitle, PatientTitleCase} from "../../utils/common";
import {firstLetterToUpperCase} from "../workTablePatients/PatientsList";
import {UserRole} from "../../helpers/UserRole";

export enum ActionLogType {
    login = "login",
    logout = "logout",
    createPatient = "createPatient",
    deletePatient = "deletePatient",
    updatePatient = "updatePatient",
    reactivation = "reactivation",
    cancelActivation = "cancelActivation",
    massTransferToMax = "massTransferToMax"
}

export const ActionLogTypeDisplayName = {
    login: "Вход в систему",
    logout: "Выход из системы",
    createPatient: `Заведение карточки ${getPatientTitle(PatientTitleCase.a)}`,
    deletePatient: `Удаление карточки ${getPatientTitle(PatientTitleCase.a)}`,
    updatePatient: `Изменение карточки ${getPatientTitle(PatientTitleCase.a)}`,
    reactivation: "Сообщение о повторной активации",
    cancelActivation: "Отмена активации",
    massTransferToMax: "Массовый перевод в Max"
}

export const ActionLogTypeNames: { value: ActionLogType, text: string }[] = [
    {value: ActionLogType.login, text: ActionLogTypeDisplayName.login},
    {value: ActionLogType.logout, text: ActionLogTypeDisplayName.logout},
    {value: ActionLogType.createPatient, text: ActionLogTypeDisplayName.createPatient},
    {value: ActionLogType.deletePatient, text: ActionLogTypeDisplayName.deletePatient},
    {value: ActionLogType.updatePatient, text: ActionLogTypeDisplayName.updatePatient},
    {value: ActionLogType.reactivation, text: ActionLogTypeDisplayName.reactivation},
    {value: ActionLogType.cancelActivation, text: ActionLogTypeDisplayName.cancelActivation},

    /* в соответствии с требованием задачи PATRONAZH-327 данный функционал пока отключаем
    {value: ActionLogType.massTransferToMax, text: ActionLogTypeDisplayName.massTransferToMax}, */
];

export const ActionLogUserRoleNames: { value: UserRole, text: string }[] = [
    {value: UserRole.ADMIN, text: "Администратор"},
    {value: UserRole.DOCTOR, text: firstLetterToUpperCase(getDoctorTitle(DoctorTitleCase.im))},
    {value: UserRole.OBSERVER, text: "Наблюдатель"},
];

export interface ActionLogCreatorModel {
    id?: string;
    displayName: string;
    login: string;
    role: UserRole;
}

export interface ActionLogTypeDescriptorModel {
    id: ActionLogType;
    displayName: typeof ActionLogTypeDisplayName;
}

export interface ActionLogObjectModel {
    id: string,
    displayName: string
}

export interface ActionLogModel {
    _id: string;
    creator: ActionLogCreatorModel;
    type: ActionLogTypeDescriptorModel;
    date: Date;
    object?: ActionLogObjectModel;
}

export interface ActionLogCreateRequest {
    userId?: string;
    userRole: UserRole;
    type: ActionLogType;
}

export interface ActionLogListRequest {
    userSearch?: string,
    userRole?: UserRole,
    type?: ActionLogType,
    objectSearch?: string,
    page: number,
    limit: number,
    sort?: string,
}
export interface ActionLogListResponse extends ResponsePaginateOptions {
    docs: ActionLogModel[]
}